module.exports = __webpack_public_path__ + "static/media/wenjianx.47c87465.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wenjianx.png
// module id = 1869
// module chunks = 0 1